import React from "react";
import Layout from "../components/organisms/Layout";
import VideoTabs from "../components/pages/mode-of-use/VideoTabs";

const ModeOfUse = ({}) => {
	return (
		<Layout>
			<VideoTabs />
		</Layout>
	);
};

export default ModeOfUse;
